var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.collapsed)?_c('button',{staticClass:"btn-xs icon feature-intro-revealer",attrs:{"type":"button"},on:{"click":function($event){return _vm.onClick()}}},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.lang.get('shared.click_to_learn_more')))]),_vm._v(" "),_c('i',{staticClass:"af-icons af-icons-info"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }